import React, { useState, useEffect } from "react";
import Select from 'react-select';
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
const incomeSources = [
    "Salary",
    "Business",
    "Interest",
    "Investment",
    "Other"
];

export default function IncomeCategoryAdd({ editIncomeData }) {
    const [income, setIncome] = useState({
        incomeSource: "",
        originalAmount: "",
        description: "",
        status: true,
    });
    const [EditValue, setEditValue] = useState(null);

  
    useEffect(() => {
        if (editIncomeData) {
            setEditValue(editIncomeData);
        }
    }, [editIncomeData]);


    useEffect(() => {
        if (EditValue) {
            setIncome({
                incomeSource: EditValue.incomeSource || "",
                originalAmount: EditValue.originalAmount || "",
                description: EditValue.description || "",
                status: typeof EditValue.status === 'boolean' ? EditValue.status : true,
            });
        }
    }, [EditValue]);

    const GST_PERCENT = 18;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setIncome({
            ...income,
            [name]: type === "checkbox" ? checked : value,
        });
    };

    const calculateGSTAmount = () => {
        const amount = parseFloat(income.originalAmount) || 0;
        return ((amount * GST_PERCENT) / 100).toFixed(2);
    };

    const calculateTotalAmount = () => {
        const amount = parseFloat(income.originalAmount) || 0;
        return (amount + parseFloat(calculateGSTAmount())).toFixed(2);
    };

    const handleSubmit = async(e) => {
        e.preventDefault();
        const data = {
            ...income,
            gstAmount: calculateGSTAmount(),
            totalAmount: calculateTotalAmount(),
        };
       
      await AddUpdate("Income/Insert_Income",data)
        setIncome({
            incomeSource: "",
            originalAmount: "",
            description: "",
            status: true,
        });
    };

    const incomeSourceOptions = incomeSources.map((src) => ({
        value: src,
        label: src,
    }));

    const customSelectStyles = {
        control: (provided, state) => ({
            ...provided,
            border: '1px solid #fdba74',
            borderRadius: 6,
            fontSize: 14,
            backgroundColor: '#fff',
            boxShadow: state.isFocused ? '0 0 0 2px rgba(253, 186, 116, 0.2)' : 'none',
            borderColor: state.isFocused ? '#fdba74' : '#fdba74',
            minHeight: 39,
            outline: 'none',
            ':hover': {
                borderColor: '#fdba74',
            },
        }),
    };

    return (
        <div className="position-relative" >
            <h2 className="heading" style={{ color: "#ea580c", }}>Add Income Entry</h2>
            <form className="form-card" onSubmit={handleSubmit} style={{ padding: 24 }}>
                <div className="form-row" style={{ display: "flex", gap: 16 }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label >Income Source</label>
                        <Select
                            name="incomeSource"
                            value={incomeSourceOptions.find(
                                (option) => option.value === income.incomeSource
                            )}
                            onChange={(selectedOption) =>
                                handleChange({
                                    target: {
                                        name: 'incomeSource',
                                        value: selectedOption ? selectedOption.value : '',
                                    },
                                })
                            }
                            options={incomeSourceOptions}
                            placeholder="Select income source"
                            isClearable
                            styles={customSelectStyles}
                        />

                    </div>

                </div>

                <div className="form-row" style={{ display: "flex", gap: 16, marginTop: 16 }}>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label >Original Amount</label>
                        <input
                            type="number"
                            name="originalAmount"
                            placeholder="Enter amount before GST"
                            value={income.originalAmount}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label >GST Amount (18%)</label>
                        <input
                            type="number"
                            value={calculateGSTAmount()}
                            readOnly
                        />
                    </div>
                    <div className="form-group" style={{ flex: 1 }}>
                        <label >Total Amount (Incl. GST)</label>
                        <input
                            type="number"
                            value={calculateTotalAmount()}
                            readOnly
                        />
                    </div>
                </div>

                <div className="form-row" style={{ display: "flex", gap: 16, marginTop: 16 }}>

                    <div className="form-group" style={{ flex: 1 }}>
                        <label >Description</label>
                        <textarea
                            name="description"
                            placeholder="Additional details about this income"
                            value={income.description}
                            onChange={handleChange}
                            rows={3}
                        />
                    </div>
                </div>

                <div className="form-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 16 }}>
                    <div className="d-flex">
                        <label style={{ marginRight: 8 }}>Status</label>
                        <label className="switch" style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <input
                                type="checkbox"
                                name="status"
                                checked={income.status}
                                onChange={handleChange}
                            />
                            <span style={{ color: income.status ? '' : '#888', fontWeight: 500 }}>{income.status ? 'Active' : 'Inactive'}</span>
                        </label>
                    </div>
                    {/* <button type="submit" style={{ background: "#ea580c", color: "#fff", border: "none", padding: "10px 32px", borderRadius: 6, fontWeight: 600, fontSize: 16, cursor: "pointer", marginLeft: "auto", boxShadow: "0 2px 4px #0001" }}>
                        SUBMIT INCOME
                    </button> */}
                    <div className="button-group">
                        {false ? (
                            <button type="submit">
                                Update
                            </button>
                        ) : (
                            <button type="submit">
                                SUBMIT INCOME
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </div>
    );
}






